import { logSafeErrorWithoutCustomerDataWrapper } from '@jira/polaris__lib-logging/src/logSafeErrorWithoutCustomerDataWrapper.tsx';
import { setUserProperties } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { GLOBAL_VIEWS_SECTION_MESSAGE_DISMISSED } from '../../../constants.tsx';
import type { Props, State } from '../../../types.tsx';

export const setGlobalViewsSectionMessageDismissed =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		const state = getState();

		setState({
			...state,
			globalViews: {
				sectionMessageDismissed: true,
			},
		});

		try {
			await setUserProperties(accountId, GLOBAL_VIEWS_SECTION_MESSAGE_DISMISSED, 'true');
		} catch (error) {
			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.global-views.section-message',
				`Failed to set user property with key: ${GLOBAL_VIEWS_SECTION_MESSAGE_DISMISSED}`,
				error instanceof Error ? error : undefined,
			);
		}
	};
